import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { Control, FieldName, useWatch } from 'react-hook-form';

import { IFormInput } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/VacationBalanceData/useVacationBalanceDataForm';
import { BalanceSummaryEditCell } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/VacationBalanceData/VacationAndSupplementalBalances/SupplementalBalanceSummary/BalanceSummaryEditCell';

import { useSxStyles } from './useStyles';

export type SupplementalBalanceSummaryProps = {
  control: Control<IFormInput>;
  totalFieldName: FieldName<IFormInput>;
  spentFieldName: FieldName<IFormInput>;
  labels: {
    name: string;
    total: string;
    spent: string;
  };
  editMode: boolean;
};

export const SupplementalBalanceSummary = (
  props: SupplementalBalanceSummaryProps,
) => {
  const { control, totalFieldName, spentFieldName, labels, editMode } = props;

  const sxStyles = useSxStyles();

  const [total, spent] = useWatch({
    control,
    name: [totalFieldName, spentFieldName],
  });

  if (!labels.name.trim()) {
    return <></>;
  }

  return (
    <Paper variant={'outlined'} sx={sxStyles.paper}>
      <Table size={'small'} sx={sxStyles.table}>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>{labels.name}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{labels.total}</TableCell>
            <BalanceSummaryEditCell
              control={control}
              cellValue={total}
              fieldName={totalFieldName}
              editMode={editMode}
            />
          </TableRow>
          <TableRow>
            <TableCell>{labels.spent}</TableCell>
            <BalanceSummaryEditCell
              control={control}
              cellValue={spent}
              fieldName={spentFieldName}
              editMode={editMode}
            />
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
};
